import BaseCommand from "@/models/api/commands/BaseCommand";

export class ChangeHasCostDocumentCommand extends BaseCommand {
  CommandName = "ChangeHasCostDocument";
  Command: {
    Value: boolean;
    BookingItemTmpId: string;
  };
  constructor(sessionId: string, operationId: string, bookingItemTmpId: string, value: boolean) {
    super(sessionId, operationId);
    this.Command = { Value: value, BookingItemTmpId: bookingItemTmpId };
  }
}
